export const strip = (str) => {
  return str.replace(/^\s+|\s+$/g, '');
};
